import React, {useState} from 'react';
import CustomLoader from "../common/Loader";
import { Modal } from 'react-bootstrap';
import * as Icon from "react-feather";
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from '@codemirror/lang-javascript';
import {getForm, saveFormCustomCode} from "../../services/formService";
import { toaster } from "../../config";
import {isNullOrEmpty} from "../common/commonFuncs";
function FormCustomCode({Form_ID}) {
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const functionHeader =
        "async function onLoad(PrimaryKey, SecondaryID, Widgets, functions) {\n" +
        "  /* Place your Javascript here to run when the form loads. Do not modify the function header */\n"

    const [code, setCode] = useState('');

    const handleOpenModal = async () => {
        setLoading(true);
        setOpenModal(true);

        let { data } = await getForm(parseInt(Form_ID));
        data = data[0];
        if(isNullOrEmpty(data.Custom_Code)) {
            setCode(functionHeader + "}");
        }
        else {
            setCode(functionHeader + "  " + data.Custom_Code + "\n}");
        }
        setLoading(false);
    }

    /**
     * Saves the code inside onLoad function
     */
    const handleSave = async () => {
        // get code inside function
        let temp = code.replace(functionHeader, "");
        let codeToSave = temp.substring(0, temp.lastIndexOf("}") - 1).trim();
        console.log(codeToSave);

        let { data } = await saveFormCustomCode(Form_ID, codeToSave);
        if (data.includes('Success')) {
            toaster('success', 'Saved')
            setOpenModal(false);
        }
        else {
            toaster('error', 'Save Failed')
        }
    }

    return (
        <>
            <button className="btn btn-primary" onClick={handleOpenModal}>
                <Icon.Code/>
            </button>

            <Modal size='xl' show={openModal} onHide={() => setOpenModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Form Javascript</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ?
                        <CustomLoader/>
                        :
                        <CodeMirror
                            value={code}
                            height="500px"
                            extensions={[javascript({ jsx: true })]}
                            onChange={(value) => setCode(value)}
                        />
                    }

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={handleSave}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
};

export default FormCustomCode;